import { StatusAvaliadoEnum } from 'graphql/types.generated'

import { MarcosDesenvolvimentoModel } from './MarcosDesenvolvimentoView'

// TODO foundation - remover ao integrar o load
export const reflexosNeuroOptions: MarcosDesenvolvimentoModel = {
  marcoDesenvolvimento: [
    {
      id: 1,
      descricao: 'Apoio plantar',
      hint:
        'Ao segurar a criança em pé pelas axilas, as pernas, que antes estavam fletidas, se estendem ao tocar com as plantas do pé uma superfície plana.',
      statusButton: StatusAvaliadoEnum.PRESENTE,
      status: StatusAvaliadoEnum.PRESENTE,
      dataAvaliacao: new Date().toDateString(),
    },
    {
      id: 2,
      descricao: 'Sucção',
      hint: 'Quando um objeto toca os lábios da criança desencadeia os movimentos de sucção dos lábios e da língua.',
      statusButton: StatusAvaliadoEnum.AUSENTE,
      status: StatusAvaliadoEnum.AUSENTE,
      dataAvaliacao: new Date().toDateString(),
    },
    {
      id: 3,
      descricao: 'Preensão palmar',
      hint: 'Com uma leve pressão do dedo do examinador nas palmas das mãos da criança, observa-se a flexão dos dedos.',
    },
    {
      id: 4,
      descricao: 'Preensão dos artelhos',
      hint: 'Com uma leve pressão do dedo do examinador na base dos artelhos, observa-se a flexão dos dedos.',
    },
    {
      id: 5,
      descricao: 'Reflexo cutâneo-plantar',
      hint:
        'Ao estimular a porção lateral dos pés da criança a partir do calcâneo até os artelhos, os dedos adquirem postura em extensão.',
    },
    {
      id: 6,
      descricao: 'Reflexo de Moro',
      hint: 'Este reflexo pode ser medido ao se segurar a criança pelas mãos e liberar bruscamente seus braços.',
    },
    {
      id: 7,
      descricao: 'Reflexo tônico-cervical',
      hint:
        'Quando da rotação da cabeça da criança para um lado, consequentemente ocorre a extensão do membro superior e inferior do lado onde a cabeça foi posicionada, além disso, ocorre a flexão dos membros superior e inferior do outro lado.',
    },
  ],
}
